import { render, staticRenderFns } from "./PostDataWrapper.vue?vue&type=template&id=328a5328&"
import script from "./PostDataWrapper.vue?vue&type=script&lang=js&"
export * from "./PostDataWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "3dff7d74"
  
)

export default component.exports